import React from 'react';
import { useTranslation } from 'react-i18next';
import { isNil } from 'lodash';
import Skeleton from '@material-ui/lab/Skeleton';
import EmptyResultSetMessage from 'components/@common/EmptyResultSetMessage';

const EmptyReportMessage: React.FC = () => {
  const { t } = useTranslation('Reports');

  return <EmptyResultSetMessage variant="custom" message={t('emptyMessage')} messageVariant="h6" />;
};

export interface MaybeRenderReportElementProps {
  loading: boolean;
  loadingHeight?: number;
  reportData?: any[] | readonly any[];
  reportDataProp?: string;
}

const MaybeRenderReportElement: React.FC<MaybeRenderReportElementProps> = ({
  loading,
  loadingHeight = 250,
  reportData = [],
  reportDataProp,
  children
}) => {
  if (loading) return <Skeleton height={loadingHeight} />;

  const isEmpty =
    reportData.length === 0 ||
    (reportDataProp && reportData.every(element => isNil(element[reportDataProp])));

  return isEmpty ? <EmptyReportMessage /> : (children as React.ReactElement);
};

export default MaybeRenderReportElement;
